<template>
  <v-row no-gutters>
    <v-col 
      v-if="showField('horizontal')"
      cols="6" 
      class="_pr-"
    >
      <SectionAlignment v-model="selectedSection" keyValue="text-position" type="horizontal"/>
    </v-col>

    <v-col 
      v-if="showField('vertical')"
      cols="6" 
      class="_pl-"
    >
      <SectionAlignment v-model="selectedSection" keyValue="text-position-vertical" type="vertical"/>
    </v-col>
  </v-row>
</template>

<script>
import Select from '../../../_v2/ui/Select.vue'
import SectionAlignment from '../../../_v2/utils/SectionAlignment.vue'

export default {
  name: 'Alignment',
  components: { Select, SectionAlignment },
  props: {
    selectedSection: {type: Object, required: true},
    hide: {type: Array, default: () => ([])}, // ['horizontal', 'vertical'] 
  },

  methods: {
    showField (type) {
      return !this.hide.includes(type)
    }    
  }  
}
</script>